import { PlaceRegister } from '../../interfaces/PlaceRegister';
import { PlaceUpdate } from '../../interfaces/PlaceUpdate';
import httpClient from '../../shared/services/httpClient';

export const PlaceCreate = async (data: PlaceRegister, promotionalCode?: string) => {
  const query = promotionalCode ? `?code=${encodeURIComponent(promotionalCode)}` : '';
  const response = await httpClient.post(`/place/create${query}`, data);
  return response.data;
};

export const PlaceUpdateDto = async (data: PlaceUpdate) => {
  const response = await httpClient.put('/place/update', data);
  return response.data;
};

export const PlaceRemove = async (placeId: number) => {
  const response = await httpClient.delete(`/place/delete/id/${placeId}`);
  return response.data;
};
